import { usePathResolver } from 'lib/core/hooks'
import { useProductBySku } from 'lib/modules/catalog/hooks/useProductBySku'

interface Params {
  enableGTM: boolean
}

export const useProductByPath = (params?: Params) => {
  const { sku } = usePathResolver()
  const { product, isFetching, isLoading, isError } = useProductBySku({
    sku: sku,
    enableGTM: params?.enableGTM
  })

  return {
    product, isFetching, isLoading, isError
  }
}
